import router from "./router";
import store from "./store";
import { getToken, removeToken } from "@/common/js/auth.js";
const USER = "__user__";
import storage from "good-storage";
import { jcrcLogin } from "@/api/login.js";
// 路由白名单(不用权限)
const whiteList = [
  "/",
  "/Login",
  "/CourseClassify",
  "/merchants",
  "/personmerchants",
  "/businessmerchants",
  "/OrganClassify",
  "/searchcourse",
  "/organcourse",
  "/OrganClass",
  "/CourseClass",
  "/BroadcastNav",
  "/BroadcastDetails",
  "/TeacherStrength",
  "/OrganDetails",
  "/Wrong",
  "/CourseDetails",
  "/CourseDetailsForMobile",
  "/ChapterDetails",
  "/aboutdownload",
  "/iphonedownload",
  "/aboutus",
  "/otheraboutus",
  "/AboutCompany",
  "/AboutCompany/AboutUs",
  "/AboutCompany/ContactUs",
  "/wapsearchcourse",
  "/wapcourseClassify",
  "/Forget",
  "/wapcoursetypeclassify",
  "/examination",
  "/exresults",
  "/promote",
  "/myPromote",
  "/promoteStats",
  "/promoteIncomeDetail",
  "/promoteRule",
  "/promoteGuide",
  "/applyStudy",
  "/applyStudyFlow",
  "/applyStudyResult"
];

// 全局守卫
router.beforeEach((to, from, next) => {
  // next()
  if (getToken() || whiteList.indexOf(to.path) !== -1) {
    // 如果有token 或者 在免登录白名单，直接进入
    // jcrcIsLogin(to, from, next);
    next();
  } else {
    next("/Login"); // 否则全部重定向到登录页
  }
});

// 全局后置，结束进度条
router.afterEach(() => {
  // 如果vuex里面的userid 与 storage里面的userid不同，说明有新的用户登录，刷新当前页面，将数据
  // 刷新为最新用户的数据
  if (
    storage.get(USER) &&
    store.getters.user &&
    store.getters.user.id !== storage.get(USER).id
  ) {
    location.reload();
    return;
  }
});

//酒城人才跳转单独处理, 此处2023-02-28新增，酒城平台跳转过来地址带有authToken，需要退出当前登录，重新调用第三方登录接口
function jcrcIsLogin(to, from, next) {
  const path = to.path;
  console.log("path :>> ", path);
  const authToken = to.query.f;
  console.log("authToken :>> ", authToken);
  // 是否是课程详情页
  if (
    path == "/CourseDetails" &&
    authToken &&
    authToken.length > 0 &&
    authToken != null
  ) {
    if (getToken()) {
      // 退出登录操作
      console.log("退出登录");
      removeToken();
      storage.clear();
    }
    getUserJcrcLogin(authToken, next);
  } else {
    console.log("无authToken");
    next();
  }
}
// 新增的酒城人才第三方登录
function getUserJcrcLogin(authToken, next) {
  let obj = {
    f: authToken
  };
  jcrcLogin(obj)
    .then(res => {
      let user = res.data;
      // 保存到token和vuex里面
      setToken(user.userToken);
      storage.set(USER, user);
      store.commit("setStoreUser", user);
      store.commit("setUserId", user.id);
      console.log("调用酒城后台登录成功");
      next();
    })
    .catch(res => {
      next();
      console.log("调用酒城后台登录失败");
    });
}



// WEBPACK FOOTER //
// ./src/permission.js